import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Box, Typography, FormControl, Select, MenuItem, Button, Tabs, Tab } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { ParentProvider, useParentContext } from "../features/parent/ParentContext";
import { getSchoolInfo } from "../utils/schoolInfo";

const PRIMARY = "#605DFF";
const BORDER  = "#e2e8f0";

const NAV_ITEMS = [
  { label: "Dashboard",     path: "/parent/dashboard" },
  { label: "Attendance",    path: "/parent/attendance" },
  { label: "Fees",          path: "/parent/fees" },
  { label: "Timetable",     path: "/parent/timetable" },
  { label: "Report Cards",  path: "/parent/report-cards" },
];

function ParentTopBar() {
  const navigate = useNavigate();
  const { kids, selectedId, setSelectedId } = useParentContext();
  const parentInfo = JSON.parse(sessionStorage.getItem("parentInfo") || localStorage.getItem("parentInfo") || "null");
  const [schoolName, setSchoolName] = useState("");

  useEffect(() => { getSchoolInfo().then((info) => setSchoolName(info.schoolName)); }, []);

  const currentTab = NAV_ITEMS.findIndex((n) => window.location.pathname.startsWith(n.path));

  const handleLogout = () => {
    sessionStorage.removeItem("parentToken"); sessionStorage.removeItem("parentInfo");
    localStorage.removeItem("parentToken"); localStorage.removeItem("parentInfo");
    navigate("/parent/login");
  };

  return (
    <Box sx={{ bgcolor: "#fff", borderBottom: `1px solid ${BORDER}`, position: "sticky", top: 0, zIndex: 10 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: { xs: 2, md: 3 }, py: 1.5, flexWrap: "wrap", gap: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 32, height: 32, borderRadius: "8px", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: 14 }}>E</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 800, fontSize: 15, lineHeight: 1.2 }}>{schoolName || "Parent Portal"}</Typography>
            {schoolName && <Typography sx={{ fontSize: 10.5, color: "#94a3b8" }}>Parent Portal</Typography>}
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {kids.length > 1 && (
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <Select value={selectedId || ""} onChange={(e) => setSelectedId(e.target.value)}>
                {kids.map((k) => <MenuItem key={k._id} value={k._id}>{k.name}</MenuItem>)}
              </Select>
            </FormControl>
          )}
          <Typography sx={{ fontSize: 13, color: "#64748b", display: { xs: "none", sm: "block" } }}>{parentInfo?.name}</Typography>
          <Button size="small" startIcon={<LogoutIcon sx={{ fontSize: 16 }} />} onClick={handleLogout}
            sx={{ textTransform: "capitalize", fontSize: 12.5, color: "#ef4444" }}>
            Logout
          </Button>
        </Box>
      </Box>

      <Tabs value={currentTab === -1 ? 0 : currentTab} variant="scrollable" scrollButtons="auto"
        TabIndicatorProps={{ style: { backgroundColor: PRIMARY } }} sx={{ px: { xs: 1, md: 3 } }}>
        {NAV_ITEMS.map((item) => (
          <Tab key={item.path} label={item.label} component={NavLink} to={item.path}
            sx={{ textTransform: "capitalize", fontSize: 13, fontWeight: 600, minHeight: 44 }} />
        ))}
      </Tabs>
    </Box>
  );
}

export default function ParentLayout() {
  return (
    <ParentProvider>
      <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc" }}>
        <ParentTopBar />
        <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: "auto" }}>
          <Outlet />
        </Box>
      </Box>
    </ParentProvider>
  );
}
